<template>
  <odd-page title="Post Purchase Content Editor" :subtitle="name">
    <template v-slot:header>
      <div class="w-100 d-flex flex-row justify-content-end align-items-center">
        <d-dropdown
          theme="dark"
          size="sm"
          noCaret
          class="mx-2 radius"
          round
          right
          closeOnClick
        >
          <template v-slot:button-content>
            <i class="material-icons">more_horiz</i>
          </template>
          <template>
            <d-dropdown-item
              @click="handleEditEmail()"
              tag="button"
              :icon="add"
              :iconTheme="primary"
              class="btn-sm"
            >
              Edit Post Purchase Email
            </d-dropdown-item>
            <d-dropdown-item
              @click="handleEditProduct()"
              tag="button"
              :icon="add"
              :iconTheme="primary"
              class="btn-sm"
            >
              Edit Product
            </d-dropdown-item>
          </template>
        </d-dropdown>
      </div>
    </template>
    <template>
      <d-container>
        <d-row>
          <d-col cols="12" xl="8" class="product-email-editor-container">
            <EmailEditor
              v-if="data !== null"
              :onSave="handleOnSave"
              :data="data"
              editorType="page"
            />
          </d-col>
          <d-col cols="12" xl="4">
            <div class="">
              <!-- <p class="h6 py-2">
                Reference the customer, and their order details by including the
                following string/text within your email template
              </p> -->
              <table class="table w-100">
                <tbody>
                  <tr v-for="t in templateTags" :key="t.tag">
                    <td>
                      <kbd
                        @click="copyToClipboard(t.tag)"
                        class="cursor-pointer"
                        title="Click to copy"
                        >{{ t.tag }}</kbd
                      >
                    </td>
                    <td class="w-100">
                      {{ t.description }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </d-col>
        </d-row>
      </d-container>
    </template>
  </odd-page>
</template>

<script>
import EmailEditor from "../../components/EmailEditor";
import Page from "@/components/layout/Page/Page.vue";

export default {
  data() {
    return {
      data: null
    };
  },
  created() {
    this.$store.dispatch("products/get", this.$route.params.key);
    this.$store
      .dispatch("products/getContent", this.$route.params.key)
      .then(data => {
        this.data = data.post_purchase_page_content;
      });
  },
  computed: {
    name() {
      return !!this.$store.state.products.editProduct
        ? this.$store.state.products.editProduct.name
        : "  ";
    }
  },
  components: { EmailEditor, "odd-page": Page },
  methods: {
    copyToClipboard(str) {
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$toasted.show(`Copied ${str} to clipboard`, {
        position: "bottom-right",
        duration: 2000
      });
    },
    handleEditProduct() {
      this.$router.push({
        name: "products__edit",
        params: { key: this.$route.params.key }
      });
    },
    handleEditEmail() {
      this.$router.push({
        name: "products__edit__email",
        params: { key: this.$route.params.key }
      });
    },
    handleOnSave(content) {
      const updatedContent = {
        key: this.$route.params.key,
        post_purchase_page_content: content
      };
      this.$store
        .dispatch("products/updateContent", updatedContent)
        .then(data => {
        });
    }
  }
};
</script>

<style scoped>
.product-email-editor-container {
  max-width: 850px !important;
}
</style>
